import type { CollectionManagerState } from './types';

export const initialState: CollectionManagerState = {
  sider_state: 'loading',
  sider_resourceID: '',
  sider_resourceName: '',
  sider_resourceTitle: '',
  sider_resourceState: '',
  sider_resourceCover: '',
  sider_resourceType: [],
  sider_resourceVersions: [],
  sider_isChoice: false,
  sider_showPage: '',
  sider_hasAuthProblem: false,
  sider_policies: [],

  version_pageState: 'loading',
  version_resourceID: '',
  version_version: '',
  version_versions: [],
  version_resourceInfo: null,
  version_resourceTypeConfig: {
    isSupportDownload: false,
    isSupportOptionalConfig: false,
    uploadEntry: [],
  },
  rss_syncProgress: null,
  version_collectionItemsSetting: {
    collection_sort_list: 'collection_sort_ascending',
    collection_item_title: 'collection_item_title_rtitle',
    collection_item_no_display: 'collection_item_no_display_show',
    collection_item_image_display: 'collection_item_image_display_show',
    collection_item_descr_display: 'collection_item_descr_display_show',
    collection_view: 'collection_view_list',
  },
  version_resourceKeywords: '',
  version_collectionItems: [],
  version_resources_state: 'loading',
  version_resources_totalCount: 0,
  version_resources_pageCurrent: 1,
  version_resources_pageSize: 10,
  version_descriptionText: '',
  version_graphShow: true,
  version_systemProperties: [],
  version_propertyKeysSort: [],
  version_customProperties: [],
  version_customConfigurations: [],
  version_directDependencies: [],
  version_baseUpcastResources: [],
  version_authExcludedItems: [],
  version_reload: 0,
  version_draftSaving: false,
  version_draftSaveTime: '',
  version_collectionItemsChanged: false,
  version_otherChanged: false,

  info_pageState: 'loading',
  info_resourceID: '',
  info_resourceInfo: null,
  info_title_IsEditing: false,
  info_title_Input: '',
  info_title_Error: '',
  info_introduction_EditorText: '',
  info_username: '',
  info_updateSetting: {
    isFinish: false,
    automatic: false,
    conditionType: 'every',
    conditions: [
      {
        key: 'resourceTitle',
        limitOperatorType: 'INCLUDES',
        value: '',
        valueError: '',
      },
    ],
  },

  info_hasPermission: true,
};
